<template>
<panel>
  <p slot="header">
    Szablony
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="add_circle" color="primary" @click="$router.push({name: 'admin.templates.create'})" >Dodaj szablon</ui-button>
  </p>
  <templates-list></templates-list>
</panel>

</template>
<script>
import Templates from '../../services/Templates'
import EventEmitter from '../../services/EventEmitter'

export default {
  data () {
    return {
      modal: {
        show: false,
        title: 'Dodaj szablon',
        baseCreateTitle: 'Dodaj szablon',
        baseUpdateTitle: 'Edytuj szablon'
      },
      item: Templates.getBaseItem()
    }
  },
  methods: {
    onTemplatesChange (e) {
      this.modal.show = false
      EventEmitter.$emit('templates.reload', e)
    }
  },
  mounted () {
    EventEmitter.$on('templates.show-edit', item => {
      this.item = item
      this.showUpdateForm()
    })
  }
  // events: {
  //   'templates.show-edit': function (item) {
  //     this.item = item
  //     this.showUpdateForm()
  //   }
  // }
}

</script>


// WEBPACK FOOTER //
// Dashboard.vue?5c1f1244